import React, { useState, useEffect } from "react";
import {
  Button,
  TableRow,
  Table,
  TableHead,
  TableBody,
  TableCell, TableContainer,
  Paper,
  FormControl,
  MenuItem,
  Select,
  Card,
  Box,
  Typography,
  Avatar,
  Chip,
  Collapse,
  InputAdornment,
  TextField,
  IconButton,
  Tooltip,
  Checkbox,
} from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import FilterListIcon from '@material-ui/icons/FilterList';
import CloseIcon from '@material-ui/icons/Close';
import SchoolIcon from '@material-ui/icons/School';
import PersonIcon from '@material-ui/icons/Person';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import StudentService from "./Locality/Service/studentService";
import SoundMasterService from "./Locality/Service/soundMasterService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import TeacherService from "./Locality/Service/teacherService";

const useStyles = makeStyles((theme) => ({
  tableOverflow: {
    overflowX: "auto",
  },
  pageHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  pageTitle: {
    fontWeight: 700,
    fontSize: '1.9rem',
    color: '#0f2d4d',
    lineHeight: 1.2,
  },
  pageSubtitle: {
    color: '#6b7280',
    fontSize: '0.9rem',
    marginTop: 2,
  },
  noteBanner: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: '#eef4ff',
    border: '1px solid #d6e4ff',
    marginBottom: theme.spacing(2),
  },
  noteIconWrap: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: '#1769d6',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  filtersCard: {
    borderRadius: 14,
    border: '1px solid #e6eaf0',
    boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  filtersTopRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
  filtersChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '6px 12px',
    borderRadius: 8,
    border: '1px solid #d9dee7',
    backgroundColor: '#f7f9fc',
    cursor: 'pointer',
    fontWeight: 600,
    color: '#0f2d4d',
    userSelect: 'none',
  },
  countBadge: {
    backgroundColor: '#fff',
    color: '#1769d6',
    border: '1px solid #cfe0fb',
    borderRadius: 12,
    padding: '1px 10px',
    fontSize: '0.72rem',
    fontWeight: 700,
    marginLeft: 8,
  },
  fieldLabel: {
    fontSize: '0.78rem',
    fontWeight: 600,
    color: '#46566b',
    marginBottom: 6,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  resetBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    color: '#46566b',
    border: '1px solid #d9dee7',
  },
  tableCard: {
    borderRadius: 14,
    border: '1px solid #e6eaf0',
    boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
    overflow: 'hidden',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
  },
  iconBtnOutlined: {
    border: '1px solid #d9dee7',
    borderRadius: 8,
    padding: 8,
    color: '#46566b',
  },
  studentAvatar: {
    width: 30,
    height: 30,
    backgroundColor: '#eef4ff',
    color: '#1769d6',
    fontSize: '0.85rem',
  },
  stickyNameHead: {
    position: 'sticky',
    left: 0,
    zIndex: 5,
    backgroundColor: '#f4f6fa',
    color: '#46566b',
    fontWeight: 700,
    fontSize: '0.8rem',
    borderBottom: '1px solid #e6eaf0',
    borderRight: '1px solid #e6eaf0',
    minWidth: 200,
  },
  stickyNameCell: {
    position: 'sticky',
    left: 0,
    zIndex: 3,
    backgroundColor: '#fff',
    borderRight: '1px solid #eef1f5',
    minWidth: 200,
  },
  soundHead: {
    backgroundColor: '#f4f6fa',
    color: '#46566b',
    fontWeight: 700,
    fontSize: '0.8rem',
    borderBottom: '1px solid #e6eaf0',
    textAlign: 'center',
  },
  soundLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 24,
    height: 24,
    padding: '0 6px',
    borderRadius: 6,
    backgroundColor: '#eef4ff',
    color: '#1769d6',
    fontWeight: 700,
    textTransform: 'uppercase',
  },
}));

export default function Sound() {
  const classes = useStyles();
  const userDetails = JSON.parse(localStorage.getItem("userDetail") || "{}");
  const [studentList, setStudentList] = useState([]);
  const [sounds, setSounds] = useState([]);
  const [tableHeaders, setTableHeaders] = useState(["Student Name"]);
  const [pg, setPg] = useState(0);
  const [rpg, setRpg] = useState(5);
  const [listClassId, setListClassId] = useState("");
  const [listSectionId, setListSectionId] = useState("");
  const [addClassList, setAddClassList] = useState([]);
  const [listSectionList, setListSectionList] = useState([]);
  const [teacherHasMultipleClasses, setTeacherHasMultipleClasses] = useState(false);
  // ---- Redesigned UI state ----
  const [noteOpen, setNoteOpen] = useState(true);
  const [filtersOpen, setFiltersOpen] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  // const tableHeaders = [
  //   "Student Name",
  //   "SPL",
  //   "a",
  //   "i",
  //   "o",
  //   "u",
  //   "e",
  //   "m",
  //   "n",
  //   "r",
  //   "s",
  //   "l",
  //   "f",
  //   "h",
  //   "v",
  //   "y",
  //   "z",
  //   "w",
  //   "k",
  //   "t",
  //   "p",
  //   "b",
  //   "d",
  //   "g",
  //   "j",
  //   "c",
  //   "x",
  //   "q",
  // ];

  // const sounds = [
  //   "SPL",
  //   "a",
  //   "i",
  //   "o",
  //   "u",
  //   "e",
  //   "m",
  //   "n",
  //   "r",
  //   "s",
  //   "l",
  //   "f",
  //   "h",
  //   "v",
  //   "y",
  //   "z",
  //   "w",
  //   "k",
  //   "t",
  //   "p",
  //   "b",
  //   "d",
  //   "g",
  //   "j",
  //   "c",
  //   "x",
  //   "q",
  // ];


  const handleChangePage = (event, newPage) => {
    setPg(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRpg(parseInt(event.target.value, 10));
    setPg(0);
  };

  const effectiveClassId = listClassId || userDetails.classId || "";
  const effectiveSectionId = listSectionId || userDetails.sectionId || "";

  const loadListSectionList = (classId) => {
    if (!classId) {
      setListSectionList([]);
      return;
    }
    SectionService.findSectionList({
      schooleId: userDetails.schooleId,
      classId,
    })
      .then((res) => {
        setListSectionList(Array.isArray(res) ? res : []);
      })
      .catch(() => setListSectionList([]));
  };

  const onListClassChange = (e) => {
    const id = e.target.value;
    setListClassId(id);
    setListSectionId("");
    loadListSectionList(id);
  };

  const onListSectionChange = (e) => {
    setListSectionId(e.target.value);
  };

  // Fetch sounds list from API and combine with existing student sounds
  const getSoundsList = () => {
    const body = {
      schooleId: userDetails.schooleId || "",
      classId: effectiveClassId || "",
    };

    SoundMasterService.findSoundMasterList(body)
      .then((res) => {
        // Extract unique sound names from SoundMaster (all records, not filtered by sound: true)
        const masterSoundNames = [...new Set(
          res
            .map(item => item.name)
            .filter(name => name) // Remove empty/null names
        )];
        
        // Get existing sounds from students
        const getExistingStudentSounds = () => {
          const getSpeList = { classId: effectiveClassId };
          if (effectiveSectionId) getSpeList.sectionId = effectiveSectionId;
          return StudentService.getAllStudentById(userDetails.schooleId, getSpeList)
            .then((studentRes) => {
              // Collect all sound keys from all students
              const allStudentSounds = new Set();
              studentRes.forEach((student) => {
                if (student.sounds && typeof student.sounds === 'object') {
                  Object.keys(student.sounds).forEach(key => {
                    if (key) allStudentSounds.add(key);
                  });
                }
              });
              return Array.from(allStudentSounds);
            })
            .catch((err) => {
              console.error("Error fetching existing student sounds:", err);
              return [];
            });
        };

        // Combine master sounds with existing student sounds
        getExistingStudentSounds().then((existingSounds) => {
          // Merge both arrays and remove duplicates
          const combinedSounds = [...new Set([...masterSoundNames, ...existingSounds])];
          
          // Sort sounds alphabetically
          combinedSounds.sort();
          
          setSounds(combinedSounds);
          // Update table headers dynamically
          setTableHeaders(["Student Name", ...combinedSounds]);
        });
      })
      .catch((err) => {
        console.error("Error fetching sounds list:", err);
        // Fallback: try to get existing sounds from students
        const getSpeList = { classId: effectiveClassId };
        if (effectiveSectionId) getSpeList.sectionId = effectiveSectionId;
        StudentService.getAllStudentById(userDetails.schooleId, getSpeList)
          .then((studentRes) => {
            const allStudentSounds = new Set();
            studentRes.forEach((student) => {
              if (student.sounds && typeof student.sounds === 'object') {
                Object.keys(student.sounds).forEach(key => {
                  if (key) allStudentSounds.add(key);
                });
              }
            });
            const existingSounds = Array.from(allStudentSounds).sort();
            setSounds(existingSounds);
            setTableHeaders(["Student Name", ...existingSounds]);
          })
          .catch((studentErr) => {
            setSounds([]);
            setTableHeaders(["Student Name"]);
          });
      });
  };

  const getStudentList = () => {
    const getSpeList = { classId: effectiveClassId };
    if (effectiveSectionId) getSpeList.sectionId = effectiveSectionId;
    StudentService.getAllStudentById(userDetails.schooleId, getSpeList)
      .then((res) => {
        const studentDetails = res.map((student) => {
          // Ensure each student has a sounds object; initialize if missing
          const soundsObj = student.sounds || {};
          sounds.forEach((sound) => {
            if (!(sound in soundsObj)) {
              soundsObj[sound] = false; // Initialize sound as unchecked
            }
          });
          return {
            _id: student._id,
            studentName: `${student.firstName} ${student.lastName}`,
            sounds: soundsObj,
          };
        });
        setStudentList(studentDetails);
      })
      .catch((err) => {
        console.error("Error fetching student list:", err);
      });
  };

  const handleCheck = (student, soundKey) => {
    // Get the current checked state
    const currentValue = student.sounds[soundKey] || false;
    const newValue = !currentValue;
    
    // Ensure all sounds from master list are included in the update
    const soundsObj = { ...student.sounds };
    // Initialize all sounds from master list if not present
    sounds.forEach((sound) => {
      if (!(sound in soundsObj)) {
        soundsObj[sound] = false;
      }
    });
    // Update the specific sound that was checked/unchecked
    soundsObj[soundKey] = newValue;

    // Update the student's sound locally
    const updatedStudent = {
      ...student,
      sounds: soundsObj,
    };

    // Update the student list state immediately for better UX
    const updatedList = studentList.map((s) =>
      s._id === student._id ? updatedStudent : s
    );
    setStudentList(updatedList);

    // Call API to update the student
    StudentService.upadeStudent(updatedStudent)
      .then((res) => {
        // Don't refetch immediately - keep the local state
        // The state is already updated above, so no need to refetch
        console.log("Student sound updated successfully");
      })
      .catch((err) => {
        console.error(err.response?.data?.message || "Error updating student");
        // On error, revert the local state by refetching
        getStudentList();
      });
  };

  useEffect(() => {
    if (!userDetails.schooleId) return;
    AddClassService.getAllAddClass(userDetails.schooleId)
      .then((res) => setAddClassList(Array.isArray(res) ? res : []))
      .catch(() => setAddClassList([]));
    if (userDetails.role === "TEACHER" && userDetails.teacherId) {
      TeacherService.getTeacherById(userDetails.teacherId)
        .then((teacher) => {
          const hasMultiple =
            Array.isArray(teacher.additionalClassAndSection) &&
            teacher.additionalClassAndSection.length > 0;
          setTeacherHasMultipleClasses(hasMultiple);
          if (userDetails.classId) {
            setListClassId(userDetails.classId);
            setListSectionId(userDetails.sectionId || "");
            SectionService.findSectionList({
              schooleId: userDetails.schooleId,
              classId: userDetails.classId,
            })
              .then((secRes) => setListSectionList(Array.isArray(secRes) ? secRes : []))
              .catch(() => setListSectionList([]));
          }
        })
        .catch(() => setTeacherHasMultipleClasses(false));
    }
  }, []);

  useEffect(() => {
    if (listClassId && teacherHasMultipleClasses) {
      loadListSectionList(listClassId);
    }
  }, [listClassId, teacherHasMultipleClasses]);

  useEffect(() => {
    if (userDetails.schooleId && effectiveClassId) {
      getSoundsList();
    }
  }, [effectiveClassId, effectiveSectionId]);

  useEffect(() => {
    if (sounds.length > 0) {
      getStudentList();
    }
    return () => {
      setStudentList([]);
    };
  }, [sounds]);

  const filteredStudents = studentList.filter((s) =>
    (s.studentName || "").toLowerCase().includes(searchTerm.toLowerCase())
  );
  const activeFilterCount = [listClassId, listSectionId].filter(Boolean).length;
  const handleResetFilters = () => {
    setListClassId("");
    setListSectionId("");
    setSearchTerm("");
    setPg(0);
  };

  return (
    <>
      {/* Page header */}
      <Box className={classes.pageHeader}>
        <Box>
          <Typography className={classes.pageTitle}>Sounds</Typography>
          <Typography className={classes.pageSubtitle}>
            Track each student's phonetic sound progress. Tick a box to mark a sound as learned.
          </Typography>
        </Box>
      </Box>

      {/* Dismissible note */}
      {noteOpen && (
        <Box className={classes.noteBanner}>
          <span className={classes.noteIconWrap}>
            <InfoOutlinedIcon style={{ fontSize: 18 }} />
          </span>
          <Box flex={1}>
            <Typography variant="subtitle2" style={{ fontWeight: 700, color: '#0f2d4d' }}>Note</Typography>
            <Typography variant="body2" style={{ color: '#46566b' }}>
              Each column is a sound. Tick or untick a cell to update a student's progress — changes save automatically.
            </Typography>
          </Box>
          <IconButton size="small" onClick={() => setNoteOpen(false)} aria-label="dismiss note">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      )}

      {/* Filters card */}
      <Card className={classes.filtersCard} elevation={0}>
        <Box className={classes.filtersTopRow}>
          <Box
            className={classes.filtersChip}
            onClick={() => setFiltersOpen((o) => !o)}
            role="button"
            tabIndex={0}
          >
            <FilterListIcon fontSize="small" />
            <span>Filters</span>
            <span className={classes.countBadge}>{activeFilterCount}</span>
            {filtersOpen ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
          </Box>
        </Box>

        <Collapse in={filtersOpen}>
          <Box mt={2}>
            <Grid container spacing={2} alignItems="flex-end">
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography className={classes.fieldLabel}>
                  <SchoolIcon style={{ fontSize: 16 }} /> Class
                </Typography>
                <FormControl fullWidth variant="outlined" size="small" disabled={!teacherHasMultipleClasses}>
                  <Select displayEmpty value={listClassId} onChange={onListClassChange}>
                    <MenuItem value=""><em>All Classes</em></MenuItem>
                    {addClassList.map(({ _id, className }) => (
                      <MenuItem key={_id} value={_id}>{className}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography className={classes.fieldLabel}>
                  <PersonIcon style={{ fontSize: 16 }} /> Section
                </Typography>
                <FormControl fullWidth variant="outlined" size="small" disabled={!teacherHasMultipleClasses || !listClassId}>
                  <Select displayEmpty value={listSectionId} onChange={onListSectionChange}>
                    <MenuItem value=""><em>All Sections</em></MenuItem>
                    {listSectionList.map(({ _id, sectionName }) => (
                      <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={6}>
                <Box display="flex" justifyContent="flex-end">
                  <Button className={classes.resetBtn} variant="outlined" onClick={handleResetFilters}>
                    Reset
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Collapse>
      </Card>

      {/* Table card */}
      <Card className={classes.tableCard} elevation={0}>
        <Box className={classes.toolbar}>
          <Box display="flex" alignItems="center" gridGap={10} flexWrap="wrap">
            <Typography variant="body2" style={{ color: '#46566b', fontWeight: 600 }}>
              {filteredStudents.length} {filteredStudents.length === 1 ? 'Student' : 'Students'}
            </Typography>
            <Chip size="small" label={`${sounds.length} Sounds`} style={{ backgroundColor: '#eef4ff', color: '#1769d6', fontWeight: 600 }} />
          </Box>
          <Box display="flex" alignItems="center" gridGap={10} flexWrap="wrap">
            <TextField
              size="small"
              variant="outlined"
              placeholder="Search by student name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ minWidth: 240 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" style={{ color: '#9aa6b6' }} />
                  </InputAdornment>
                ),
              }}
            />
            <Tooltip title="Refresh">
              <span>
                <IconButton
                  className={classes.iconBtnOutlined}
                  onClick={() => getSoundsList()}
                  disabled={!effectiveClassId}
                >
                  <RefreshIcon fontSize="small" />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        </Box>

        <TableContainer component={Paper} elevation={0} className={classes.tableOverflow} style={{ maxHeight: 540 }}>
          <Table stickyHeader className="mb-0">
            <TableHead>
              <TableRow>
                <TableCell className={classes.stickyNameHead}>Student Name</TableCell>
                {sounds.map((key) => (
                  <TableCell key={key} className={classes.soundHead}>
                    <span className={classes.soundLabel}>{key}</span>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredStudents.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={sounds.length + 1} align="center" style={{ padding: 36, color: '#9aa6b6' }}>
                    {effectiveClassId ? 'No students found.' : 'Select a class to load students.'}
                  </TableCell>
                </TableRow>
              ) : (
                filteredStudents
                  .slice(pg * rpg, pg * rpg + rpg)
                  .map((student) => (
                    <TableRow key={student._id} hover>
                      <TableCell className={classes.stickyNameCell}>
                        <Box display="flex" alignItems="center" gridGap={10}>
                          <Avatar className={classes.studentAvatar}>
                            {(student.studentName || '?').charAt(0).toUpperCase()}
                          </Avatar>
                          <span style={{ fontWeight: 600, color: '#0f2d4d' }}>{student.studentName}</span>
                        </Box>
                      </TableCell>
                      {sounds.map((soundKey) => (
                        <TableCell key={soundKey} align="center" style={{ padding: '2px 6px' }}>
                          <Checkbox
                            color="primary"
                            size="small"
                            checked={student.sounds[soundKey] || false}
                            onChange={() => handleCheck(student, soundKey)}
                          />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          rowsPerPageOptions={[5, 50, 100, 500, 1000]}
          count={filteredStudents.length}
          page={pg}
          onPageChange={handleChangePage}
          rowsPerPage={rpg}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </>
  );
}